var site = site || {};

(function($) {
  "use strict";
  Drupal.behaviors.bf_massrel = {
    attach: function(context, settings) {

      _.defaults(site, {bf_massrel: {}});

      site.bf_massrel = site.bf_massrel || {};
      site.bf_massrel.massrel_render = function(feed, placementElement, tweakCallback, postRenderHook) {

        $.getJSON('//api.massrelevance.com/estee_el/' + feed + '.json?limit=1', function(data) {
//            console.log(data);

          // Get in-page template
          var template = $('script[data-mustache-template="' + placementElement.attr('id') + '"]').html();

          // Callback that cleans the data (see bfeed_fb_v1.js for example)
          var $rendered = $(Mustache.render(template, tweakCallback(data)));

          // Attach events here

          // Popup windows link
          $('.js-social-action--pop', $rendered).click(function(e) {
            e.preventDefault();
            var reload = $(this).data('reload');
            var height = $(this).data('pop-height') ? $(this).data('pop-height') : 480;
            var width = $(this).data('pop-width') ? $(this).data('pop-width') : 640;

            var newWindow = window.open($(this).attr('href'), '', 'height=' + height + ',width=' + width);

            if (newWindow !== undefined) {
              newWindow.focus();
            }

            // reload after popup is closed. Useful for lo
            if (reload) {
              var timer = setInterval(checkChild, 500);
            }
            function checkChild() {
              if (newWindow.closed) {
                alert('child closed');
                clearInterval(timer);
                window.location.reload();
              }
            }
          });

          // Colorbox inline pop
          $('.js-social-action--inline', $rendered).colorbox({
            inline: true,
            width: '640px'
          });

          // Place rendered html in content location
          placementElement.html($rendered);

          // In case our social plugins need to do anything after DOM placed in page
          if (typeof postRenderHook === 'function') {
            postRenderHook();
          }

          // Re-trigger isotope layout
          site.bf_massrel.beauty_feed.imagesLoaded(function() {
            site.bf_massrel.beauty_feed.isotope('layout');
          });

          // Re-trigger isotope layout
          site.bf_massrel.beauty_feed.imagesLoaded(function() {
            site.bf_massrel.beauty_feed.isotope('layout');
          });

        });

      }; // site.bf_massrel.massrel_render
    } // attach
  }; // Drupal.behaviors.bf_massrel
})(jQuery);
